var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishListGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53125 2.78125L9.96094 3.25L10.4297 2.82031C11.7188 1.53125 13.5547 0.945312 15.3125 1.25781C18.0078 1.6875 20 4.03125 20 6.76562V6.96094C20 8.60156 19.2969 10.1641 18.125 11.2578L11.0547 17.8594C10.7812 18.1328 10.3906 18.25 10 18.25C9.57031 18.25 9.17969 18.1328 8.90625 17.8594L1.83594 11.2578C0.664062 10.1641 0 8.60156 0 6.96094V6.76562C0 4.03125 1.95312 1.6875 4.64844 1.25781C6.40625 0.945312 8.24219 1.53125 9.53125 2.78125C9.53125 2.82031 9.49219 2.78125 9.53125 2.78125ZM9.96094 5.90625L8.20312 4.10938C7.34375 3.28906 6.13281 2.89844 4.96094 3.09375C3.16406 3.40625 1.875 4.92969 1.875 6.76562V6.96094C1.875 8.09375 2.30469 9.14844 3.125 9.89062L10 16.2969L16.8359 9.89062C17.6562 9.14844 18.125 8.09375 18.125 6.96094V6.76562C18.125 4.92969 16.7969 3.40625 15 3.09375C13.8281 2.89844 12.6172 3.28906 11.7578 4.10938L9.96094 5.90625Z",
    fill: "#989CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishListGrey);
export default __webpack_public_path__ + "static/media/WishListGrey.5a2997c171f4363ec9b62c655ef7b4a3.svg";
export { ForwardRef as ReactComponent };